import {map} from 'rxjs/operators';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  NgZone,
  ViewEncapsulation,
} from '@angular/core';
import {AbstractControlComponent} from './abstract-control';
import {Observable} from 'rxjs';
import {ViewTabComponent} from '../viewtab.component';
import {ErrorService} from '../../../error/error.service';

@Component({
  selector: 'ctrl-checkbox',
  template: `
    <div class="app-ctrl-checkbox-container">
      <mat-checkbox [formControl]="formControl" [indeterminate]="formControl?.value === null">
        {{ getCaughtObservable(getLabel()) | async }}
      </mat-checkbox>
    </div>
  `,
  styles: [
    `
      /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
      .app-ctrl-checkbox-container .mat-checkbox-indeterminate.mat-accent .mat-checkbox-background {
        background-color: #000000;
      }

      /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
      .theme-dark
        .app-ctrl-checkbox-container
        .mat-checkbox-indeterminate.mat-accent
        .mat-checkbox-background {
        background-color: #ffffff;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CtrlCheckboxComponent extends AbstractControlComponent {
  constructor(
    parent: ViewTabComponent,
    changeDetector: ChangeDetectorRef,
    _ngZone: NgZone,
    errorService: ErrorService,
  ) {
    super(parent, 'Checked', 'Checked', changeDetector, _ngZone, errorService);
  }

  protected formatSource(source: any): any {
    if (typeof source === 'boolean') {
      return source;
    } else if (typeof source === 'string') {
      let s = source.toLowerCase().trim();
      if (s === 'true') return true;
      if (s === 'false') return false;
      return null;
    }
    return null;
  }

  protected formatTarget(value: any): any {
    return value;
  }

  getLabel(): Observable<string> {
    if (!this._config.propertyExists('Text'))
      return this._config.Caption.pipe(map(valObj => (valObj ? valObj.Values : '')));
    return this._config.getPropertyValues('Text');
  }
}
